import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

// requireAuth 헬퍼 제거 (전역 가드에서 일괄 처리)

const routes: Array<RouteConfig> = [
    {
        path: '/',
        component: require('../views/client/Wrapper.vue').default,
        children: [
            {
                path: '',
                name: 'home',
                component: require('../views/client/Home.vue').default
            },
            {
                path: 'about',
                name: 'about',
                component: require('../views/client/About.vue').default
            },
            {
                path: 'portfolio',
                name: 'portfolio',
                component: require('../views/client/Portfolio.vue').default,
                props: (route) => ({ product_no: route.query.product_no })
            },
            {
                path: 'contact',
                name: 'contact',
                component: require('../views/client/Contact.vue').default
            },
            {
                path: 'review',
                name: 'review',
                component: require('../views/client/Review.vue').default,
                props: (route) => ({ page: route.query.page || 1 })
            },
            {
                path: 'qna',
                name: 'qna',
                component: require('../views/client/QNA.vue').default,
                props: (route) => ({ page: route.query.page || 1 })
            },
            {
                path: 'article',
                name: 'article',
                component: require('../views/client/Article.vue').default,
                props: (route) => ({
                    link: route.query.link,
                    boardNo: route.query.boardNo,
                    articleNo: route.query.articleNo,
                    from: route.query.from,
                    password: route.query.password
                })
            },
            {
                path: 'writeArticle',
                name: 'writeArticle',
                component: require('../views/client/WriteArticle.vue').default,
                props: (route) => ({ from: route.query.from, editContent: route.params.editContent })
            },
        ]
    },
    {
        path: '/admin',
        component: require('../views/admin/Wrapper').default,
        children: [
            {
                path: '',
                name: 'admin',
                component: require('../views/admin/Login').default
            },
            {
                path:'adminWriteArticle',
                name: 'adminWriteArticle',
                component: require('../views/admin/WriteArticle').default
            },
            {
                path: 'apartments',
                name: 'adminApartments',
                component: require('../views/admin/Apartments').default
            },
            {
                path: 'apartments/edit',
                name: 'adminApartmentEdit',
                component: require('../views/admin/ApartmentEdit').default
            },
            {
                path: 'home-photos',
                name: 'adminHome',
                component: require('../views/admin/HomePhotos').default
            },
            {
                path: 'settings',
                name: 'adminSettings',
                component: require('../views/admin/Settings').default
            },
            {
                path: 'costs',
                name: 'adminCosts',
                component: require('../views/admin/Costs').default
            },
            {
                path: 'restore',
                name: 'adminRestore',
                component: require('../views/admin/Restore').default
            }
        ]
    },
    {
        path: '*',
        name: 'catchAll',
        redirect: '/'
    }
]


// @ts-ignore
const isIE = /*@cc_on!@*/false || !!document.documentMode;

const router = new VueRouter({
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0, behavior: 'smooth' }
        }
    },
    // mode: isIE ? 'hash' : 'history',
    mode: 'history',
    base: process.env.VUE_APP_BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const isAuthenticated = store.getters.isAdminAuthenticated

    // /admin 경로 하위에 접근하는 경우
    if (to.path.startsWith('/admin')) {
        if (to.name === 'admin' || to.name === 'adminRestore') {
            // 로그인 페이지인데 이미 로그인한 상태라면 아파트 관리 메뉴로 자동 이동 (adminRestore는 제외)
            if (to.name === 'admin' && isAuthenticated) {
                return next({ name: 'adminApartments' })
            }
            return next()
        } else {
            // 로그인하지 않은 상태로 어드민 서브 메뉴에 접근하면 로그인 페이지로 이동
            if (!isAuthenticated) {
                return next({ name: 'admin' })
            }
            return next()
        }
    }

    next()
})

export default router
